import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import useUrlState from "../StatesStore/CurrentURL";

function SignInMenuHeader() {
  const seturl = useUrlState((state) => state.seturl);
  const location = useLocation();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });
  return (
    <>
      <div className="nav-item ms-2">
        <Link
          className={`btn ${isSmallScreen ? "btn-sm" : ""}`}
          style={{
            borderRadius: "100px",
            width: isSmallScreen ? "75px" : "100px",
            color: "#0D8ED1",
            border: "1px solid #0D8ED1",
          }}
          to="/SignIn"
          onClick={() => seturl(location?.pathname)}
        >
          <span>Log in</span>
        </Link>
      </div>
      <div className="nav-item ms-2">
        <Link
          className={`btn ${isSmallScreen ? "btn-sm" : ""}`}
          style={{
            borderRadius: "100px",
            width: isSmallScreen ? "75px" : "100px",
            backgroundColor: "#0D8ED1",
            color: "white",
          }}
          to="/SignUp"
          onClick={() => seturl(location?.pathname)}
        >
          <span>Sign up</span>
        </Link>
      </div>
    </>
  );
}

export default SignInMenuHeader;
